<template>
    <div class="login-wrap">
        <div class="ms-login">
            <div class="ms-title">博朗小程序后台</div>
            <el-form :model="param" :rules="rules" ref="login" label-width="0px" class="ms-content">
                <el-form-item prop="phone">
                    <el-input v-model="param.phone" placeholder="手机号" class="input">
                        <el-button slot="prepend" icon="el-icon-lx-people"></el-button>
                    </el-input>
                </el-form-item>

                <el-form-item prop="password">
                    <el-input type="password" placeholder="password" v-model="param.password" @keyup.enter.native="submitForm()" class="input">
                        <el-button slot="prepend" icon="el-icon-lx-lock"></el-button>
                    </el-input>
                </el-form-item>
                <div class="login-btn">
                    <el-button type="primary" @click="submitForm()">登录</el-button>
                </div>
            </el-form>
        </div>
    </div>
</template>
<script>
import {
    request
} from '../common/request';
export default {

    // type:"",
    data: function () {
        return {
            param: {
                phone: '',
                password: '',
                platform: 'admin'
            },
            rules: {
                phone: [{
                    required: true,
                    message: "请输入手机号码",
                    trigger: "blur"
                },
                {
                    min: 11,
                    max: 11,
                    message: "请输入11位手机号码",
                    trigger: "blur"
                },
                {
                    pattern: /^1[0-9]{10}$/,
                    message: "请输入正确的手机号码"
                }
                ],
                password: [{
                    required: true,
                    message: '请输入密码',
                    trigger: 'blur'
                }],
            },
        };
    },
    methods: {
        submitForm() {
            let that = this;
            this.$refs.login.validate(valid => {
                if (valid) {
                    request.post("/login", this.param).then((ret) => {
                        console.log(that)
                        if (ret.code === 1) {
                            that.$message.success('登录成功');
                            localStorage.setItem('token', ret.data.token);
                            let user = JSON.stringify(ret.data.user)
                            localStorage.setItem('user', user);
                            request.get("/user/menu/list", this.param).then(async (ret) => {

                                // let vuerouter = [];
                                // ret.data.list.forEach(item => {

                                //     let data = {
                                //         component: Layout,
                                //         path: item.index,
                                //         meta: {
                                //             title: item.title,
                                //         },
                                //         children: []
                                //     }
                                //     if (item.subs.length > 0) {

                                //         item.subs.forEach(val => {
                                //             let children = appRouter.filter(ren => ren.meta.title == val.title)
                                //             data.children.push(children)
                                //         })
                                //     }
                                //     vuerouter.push(data);
                                // })

                                // this.$store.commit('adminRouter/setRouterlist', vuerouter)
                                this.$store.commit('adminRouter/setsiderRouter', ret.data.list)

                                // this.$store.dispatch('adminRouter/set_Routerlist', vuerouter)
                                this.$store.dispatch('adminRouter/set_siderRouter', ret.data.list)


                                // this.$store.commit('adminRouter/setsiderRouter', ret.data.list)
                                this.$store.dispatch("adminRouter/SET_ADMIN_ROUTER", ret.data.list).then(() => {
                                    that.$router.push('/');
                                }).catch(() => {
                                    that.$message.error("登录错误");
                                });
                            })
                            that.$router.push('/');
                        } else {
                            that.$message.error(ret.msg);
                        }

                    })
                } else {
                    this.$message.error('请输入账号和密码');
                    return false;
                }
            });
        },
    },
};
</script>

<style scoped>
.login-wrap {
    position: relative;
    width: 100%;
    height: 100%;
    background-image: url(../assets/images/bg.png);
    background-size: 100%;
}

.ms-title {
    width: 100%;
    line-height: 50px;
    text-align: center;
    font-size: 20px;
    color: #aaa;
    border-bottom: 1px solid #ddd;
}

.ms-login {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 350px;
    transform: translate(-50%, -50%);
    border-radius: 5px;
    background: #ffffff;
    opacity: 0.9;
    overflow: hidden;
}

.ms-content {
    padding: 30px 30px;
}
.input {
    width: 100% !important;
}
.login-btn {
    text-align: center;
}

.login-btn button {
    width: 100%;
    height: 36px;
    margin-bottom: 10px;
}

.login-tips {
    font-size: 12px;
    line-height: 30px;
    color: #fff;
}
</style>
